/**
* Floating Images Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Floating Images Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'floating-images-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.floating-images-content' ).each( function( key, val ) {
        window.scrollRefreshPriority--;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: 'bottom 75%',
            refreshPriority: window.scrollRefreshPriority,
            scrub: 1,
            // markers: true,
          },
        } );

        const locations = [];
        $( val ).find( '.floating-image' ).each( function( imgKey, image ) {
          const containerWidth = $( image ).closest( '.relative' ).outerWidth();
          const containerHeight = $( image ).closest( '.relative' ).outerHeight();
          const perc = ( Math.floor( Math.random() * ( 200 - 50 + 1 ) + 50 ) );

          let top = 0;
          let left = 0;
          let bottom = 0;
          let right = 0;

          let overlapped = true;
          let i = 0;

          while ( overlapped ) {
            top = ( Math.floor( Math.random() * ( containerHeight - 0 + 1 ) + 0 ) );
            left = ( Math.floor( Math.random() * ( containerWidth - 0 + 1 ) + 0 ) );
            bottom = top + $( image ).outerHeight();
            right = left + $( image ).outerWidth();

            overlapped = false;
            locations.forEach( ( val, index ) => {
              if (
                ( bottom < val.top || top > val.bottom ) ||
                ( left > val.right || right < val.left )
              ) {
                // overlapped = false;
              } else {
                overlapped = true;
              }
            } );
            i++;
            if ( i > 1000 || locations.length == 0 ) {
              overlapped = false;
            }
          }

          $( image ).css( {
            'top': top,
            'left': left,
          } );

          locations.push( {
            'top': top,
            'left': left,
            'bottom': bottom,
            'right': right,
          } );

          tl.to( image, {y: '-' + perc + '%', ease: 'linear'}, 0 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'floating-images-content', COMPONENT );
} )( app );
